
import React from 'react';
import { SimulationConfig } from './types';
import { SectionLabel } from './SectionLabel';
import { SmartInput } from './SmartInput';

interface AudioVolumeSectionProps {
  config: SimulationConfig;
  setConfig: React.Dispatch<React.SetStateAction<SimulationConfig>>;
}

export const AudioVolumeSection: React.FC<AudioVolumeSectionProps> = ({ config, setConfig }) => {
  return (
    <div className={`p-5 rounded-3xl border ${config.darkMode ? 'bg-blue-500/5 border-blue-500/10' : 'bg-blue-50 border-blue-100'} flex flex-col gap-4 shadow-sm mb-4`}>
      <SectionLabel icon="fa-volume-high" darkMode={config.darkMode}>Volume Mixer</SectionLabel>
      
      <div className="flex flex-col gap-4">
        <SmartInput 
          label="Master Volume" 
          settingKey="masterVolume"
          min={0} 
          max={2} 
          step={0.01} 
          value={config.masterVolume ?? 1.0} 
          onChange={v => setConfig(p => ({ ...p, masterVolume: v }))} 
          darkMode={config.darkMode} 
        />
        
        <SmartInput 
          label="Melody Volume" 
          settingKey="melodyVolume"
          min={0} 
          max={1} 
          step={0.01} 
          value={config.melodyVolume ?? 1.0} 
          onChange={v => setConfig(p => ({ ...p, melodyVolume: v }))} 
          darkMode={config.darkMode} 
        />
        
        <SmartInput 
          label="Collision Volume" 
          settingKey="fxVolume"
          min={0} 
          max={1} 
          step={0.01} 
          value={config.fxVolume ?? 0.8} 
          onChange={v => setConfig(p => ({ ...p, fxVolume: v }))} 
          darkMode={config.darkMode} 
        />
      </div>
    </div>
  );
};
